import { OrganisationTypeConstants, UserType, UserTypeLabels } from "../../../../../../constants";
import { ServiceError } from "../../../../../../service/Shared";

export const GUEST_WRITE_ROLE = "Guest - Write";

export const PENDING_DEVELOPER_INVITE_EXISTS_ERROR_CODE = "VALIDATION_PENDING_DEVELOPER_INVITE_EXISTS";

// The public project query can hand back a developer with an empty uuid rather than null.
const EMPTY_UUID = "00000000-0000-0000-0000-000000000000";

const hasDeveloper = (projectDeveloperUuid: string | null | undefined): boolean =>
  !!projectDeveloperUuid && projectDeveloperUuid !== EMPTY_UUID;

/**
 * The role an organisation asks for when it requests access to a project. The api requires the role to
 * fit the requesting organisation's type (BR-02870).
 *
 * A developer only asks to become the project's developer when it has none: a project holds one
 * developer (BR-02726), and asking for the role on a project that already has one would push the
 * responsible owner into the developer-swap path on accept. Otherwise it asks for Guest - Write.
 */
export const getProjectAccessRequestRole = (
  currentUserType: UserType,
  projectDeveloperUuid: string | null | undefined
): string => {
  if (currentUserType === OrganisationTypeConstants.DEVELOPER && hasDeveloper(projectDeveloperUuid)) {
    return GUEST_WRITE_ROLE;
  }

  return UserTypeLabels[currentUserType];
};

/**
 * A Developer request is refused while the project has a Developer invite awaiting a response (BR-02878).
 * The requester cannot see that invite, so the request is resent as Guest - Write instead.
 */
export const shouldRetryAsGuestWrite = (role: string, errors: ServiceError[] | undefined): boolean =>
  role === UserTypeLabels[OrganisationTypeConstants.DEVELOPER] &&
  !!errors?.some((error) => error.code === PENDING_DEVELOPER_INVITE_EXISTS_ERROR_CODE);
